import { Text, UnstyledButton, type MantineRadius } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { S3Image } from "./S3Image";
import { ZoomModal } from "./ZoomModal";
import { useSignedImageUrl } from "../../hooks/useSignedImageUrl";

// Any photo/document thumbnail rendered via S3Image, made clickable to open
// the interactive pan/zoom viewer. Drop-in wherever S3Image is used for
// display (not for editable upload previews without a value).
export function ZoomableImage({
  src,
  alt,
  h = 120,
  w,
  fit = "cover",
  radius = "md",
  emptyLabel,
  title,
  caption,
}: {
  src?: string | null;
  alt?: string;
  h?: number | string;
  w?: number | string;
  fit?: "cover" | "contain";
  radius?: MantineRadius;
  emptyLabel?: string;
  title?: string;
  caption?: string;
}) {
  const [opened, { open, close }] = useDisclosure(false);
  const { url } = useSignedImageUrl(src);
  const hasImage = !!url;

  return (
    <>
      <UnstyledButton
        onClick={hasImage ? open : undefined}
        w={w ?? "100%"}
        style={{ cursor: hasImage ? "zoom-in" : "default", display: "block" }}
      >
        <S3Image src={src} alt={alt} h={h} w={w} fit={fit} radius={radius} emptyLabel={emptyLabel} />
        {caption && (
          <Text size="xs" c="dimmed" mt={4} ta="center">
            {caption}
          </Text>
        )}
      </UnstyledButton>

      {hasImage && (
        <ZoomModal opened={opened} onClose={close} src={url} alt={alt} title={title ?? alt} />
      )}
    </>
  );
}
